import aqe from '@pushly/aqe'
import { AqeApplicationScope } from '@pushly/aqe/lib/stores/aqe'
import { RuntimeConfig } from './runtime-config'

export function setupAqe(cfg: RuntimeConfig) {
    aqe.set({
        appName: 'Halo',
        appScope: AqeApplicationScope.INTERNAL,
        storageDomain: cfg.PLATFORM_ROOT_DOMAIN,
        publicPlatformDomain: `https://${cfg.PUB_PLAT_URL}`,
        internalPlatformDomain: `https://${cfg.INT_PLAT_URL}`,
        publicApiDomain: `https://${cfg.PUB_API_URL}`,
        internalApiDomain: `https://${cfg.INT_API_URL}`,
        insightsDomain: `https://${cfg.INSIGHTS_URL}`,
        publicCdnDomain: `https://${cfg.CDN_URL}`,
        publicMediaDomain: `https://${cfg.MEDIA_URL}`,
        preferencesNamespace: 'halo',
    })
}
